"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { PracticumGroupLogo } from "@/shared/ui/practicum-logos";

export function Preloader() {
  const [show, setShow] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const hasVisited = sessionStorage.getItem("practicum_visited");
    if (hasVisited) {
      setShow(false);
    } else {
      sessionStorage.setItem("practicum_visited", "true");
      // Total display: 2.4s → then fade out (0.7s)
      const timer = setTimeout(() => setShow(false), 2400);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!isMounted) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white"
        >
          <div className="flex flex-col items-center gap-5">
            {/* Logo with typed-reveal animation */}
            <div className="relative" style={{ lineHeight: 0 }}>
              <PracticumGroupLogo height={44} className="text-foreground" />
              {/* White curtain slides from right → reveals logo left-to-right */}
              <motion.div
                initial={{ scaleX: 1 }}
                animate={{ scaleX: 0 }}
                transition={{ duration: 1.4, ease: [0.25, 0.1, 0.25, 1], delay: 0.15 }}
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "white",
                  transformOrigin: "right center",
                }}
              />
            </div>

            {/* Thin progress bar */}
            <div
              className="relative overflow-hidden rounded-full"
              style={{ width: 180, height: 1, background: "rgba(27,29,32,0.12)" }}
            >
              <motion.div
                initial={{ scaleX: 0, transformOrigin: "left center" }}
                animate={{ scaleX: 1, transformOrigin: "left center" }}
                transition={{ duration: 2.0, ease: "easeInOut", delay: 0.25 }}
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(27,29,32,0.35)",
                  borderRadius: 999,
                }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
